import { render } from "./tipsPage.vue?vue&type=template&id=633a9028"
import script from "./tipsPage.vue?vue&type=script&lang=js"
export * from "./tipsPage.vue?vue&type=script&lang=js"

import "./tipsPage.vue?vue&type=style&index=0&id=633a9028&lang=less&scope=true"

import exportComponent from "E:\\Code\\TECS\\TECS-FE-ENDUSER-NEW\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__